module.exports = "<div ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/template.html
// module id = ../node_modules/xo-credit-components/src/bml-display/template.html
// module chunks = 0